export default __webpack_public_path__ + "static/media/odoo.99b0dbea.svg";